export default __webpack_public_path__ + "static/media/og-portfolio-thumbnail.75f8d0ce.png";